import React from "react";
import { setEditId, TemplateInterface } from "../../../../store/roblox/templatesSlice";
import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import CardImage from "../../../../componets/CardImage";
import { EntityId } from "@reduxjs/toolkit";
import { destroyTemplate } from "../../../../actions/roblox/templatesActions";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../store/hooks";
import { formattedDate } from "../../../../helpers/DateHelpers";
import IconText from "../../../../componets/IconText";
import { DollarOutlined, StarOutlined } from "@ant-design/icons";

interface propsInterface {
  template: TemplateInterface;
}

const Card = ({ template }: propsInterface) => {
  const navigate            = useNavigate();
  const dispatch            = useAppDispatch();
  const formattedCreatedAt  = formattedDate(template.created_at);
  let className = 'v-roblox-templates__card';
  className += template.type_id !== 4 ? ' o-placeholder' : '';

  function onClickEdit(id: EntityId)  {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyTemplate(id));

    if (destroyTemplate.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyTemplate.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const stats = [
    <IconText icon={DollarOutlined} text={template.coins} />
  ];

  if (template.premium) {
    stats.push(<IconText icon={StarOutlined} text='premium' />);
  }

  return (
    <CardImage
      className={className}
      image={template.thumbnail_url}
      link={template.url}
      size='medium'
      stats={stats}
      options={[
        <ButtonEdit key={`edit-${template.id}`} onClick={() => onClickEdit(template.id)} />,
        <ButtonDestroy key={`destroy-${template.id}`} onClick={() => onClickDestroy(template.id)} />
      ]}
    >
      <div className='v-small_text'>
        {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
      </div>
    </CardImage>
  )
}

export default Card;
